import React from 'react';

interface ColumnResizeHandleProps {
  colData: string;
  /** Pre-translated label — used for both `aria-label` and `title`. */
  label: string;
  onResizeStart: (colData: string, e: React.PointerEvent) => void;
  onReset: (colData: string) => void;
}

/**
 * Drag affordance on the right edge of a resizable column header (plain
 * `<th>`s and grouped sub-headers). Pointer events are stopped so a grab
 * never bubbles into header content (column filter, future sort).
 * Double-click resets the column to its default width.
 */
export function ColumnResizeHandle({
  colData,
  label,
  onResizeStart,
  onReset,
}: ColumnResizeHandleProps) {
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label={label}
      title={label}
      data-resize-handle={colData}
      className="column-resize-handle"
      onPointerDown={(e) => {
        e.stopPropagation();
        onResizeStart(colData, e);
      }}
      onDoubleClick={(e) => {
        e.stopPropagation();
        onReset(colData);
      }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    />
  );
}
